export default __webpack_public_path__ + "static/media/LogoPicPayfundoverde.d5cb87ff.png";